import { Box, Collapse, FormControlLabel, Grid, Stack, Typography } from "@mui/material";
import { IOSSwitch } from "../dinamicForm/switch";
import { useTranslation } from "react-i18next";
import { IncidentPriorityGradient } from "../incidentPriorityGradient";
import { Controller, FormProvider } from "react-hook-form";
import { ResolutionTimeRow } from "../resolutionTimeRow";
import { ResolutionFirstAnswerTimeRow } from "../resolutionFirstAnswerTimeRow.index";
import { useStyles } from "./styles";
type TimePriorityProps = {
    timesBySla: {
        id: number;
        name: string;
        color: string;
        priority: number;
    }[]
    gradientColor: {
        id: number;
        name: string;
        color: string;
        priority: number;
    }[]
    name: string
    form: any
    title?: string
    subtitle?: string
    switchLabel: string
    disable:boolean
}
export function TimePriority({ timesBySla, form, title, subtitle, switchLabel, name, gradientColor, disable }: TimePriorityProps) {
    const { t } = useTranslation()
    const styles = useStyles()
    return (
        <Box sx={styles.container}>
            {!!title && <Typography my={2} variant="subtitle_grey" color='secondary.main' fontWeight='bold'>{title}</Typography>}

            {!!subtitle && <Typography variant="text_grey" fontWeight='bold'>{subtitle}</Typography>}

            <FormProvider {...form}>
                <Collapse in>
                    <Grid container rowSpacing={2}>
                        <Grid item xs={12/* 7.25 */}>
                            <Controller
                                control={form.control}
                                name={`${name}_switch_firstResponseHours`}
                                render={({ field }) => (
                                    <FormControlLabel
                                        {...field}
                                        control={<IOSSwitch checked={!!field.value} />}
                                        label={switchLabel}
                                        sx={styles.switch}
                                    />
                                )}
                            />
                        </Grid>

                        {/* <Grid item xs={1}></Grid>

                        <Grid item xs={3.75} sx={{ display: "flex", alignItems: "center" }}>
                            <Collapse in>
                                <Typography variant="subtitle_grey" color='secondary.main' fontWeight='bold'>
                                    {t("general.serviceTime.time.form.firstAnswer")}
                                </Typography>
                            </Collapse>
                        </Grid> */}

                        <Grid item xs={3.25/* 1.5 */} sx={{ display: "flex" }}>
                            <IncidentPriorityGradient
                                incidentPriorities={gradientColor}
                            />
                        </Grid>

                        {/* <Grid item xs={0.75}></Grid> */}

                        <Grid item xs={8.75/* 5 */}>
                            <Stack spacing={2}>
                                {timesBySla?.map((item, index) => (
                                    <ResolutionTimeRow
                                        key={item.id}
                                        index={index}
                                        name={name}
                                        disable={!disable}
                                    />
                                ))}
                            </Stack>
                        </Grid>

                        {/* <Grid item xs={1}></Grid>

                        <Grid item xs={3.75}>
                            <Stack spacing={2}>
                                {timesBySla?.map((item, index) => (
                                    <ResolutionFirstAnswerTimeRow
                                        key={item.id}
                                        index={index}
                                        name={name}
                                    />
                                ))}
                            </Stack>
                        </Grid> */}
                    </Grid>
                </Collapse>
            </FormProvider>
        </Box>
    )
}